import { useSelector } from 'react-redux'

import { isCenter } from '~/state/modules/user'

const Center = ({
  children
}: {
  children: JSX.Element
}): JSX.Element | null => {
  const center = useSelector(isCenter)

  return center ? children : null
}

export default Center
